export class UserProfileRequest {
  public idUsuario: number;
  public apellido: string;
  public nombre: string;
  public fechaNacimiento: string;
  public numeroDocumento: string;
  public provincia: number;
}
